// client/src/services/userVersionFileService.js
import { api } from "./api";

export const userVersionFileService = {
  // Register or replace a personal zip for a license-server user
  async registerZip(userId, versionId, filePath) {
    try {
      const response = await api.put(
        `/user-version-files/users/${userId}/versions/${versionId}`,
        { file_path: filePath }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async unregisterZip(userId, versionId) {
    try {
      const response = await api.delete(
        `/user-version-files/users/${userId}/versions/${versionId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // { users: [{ id, email, file|null }] } for one version
  async getVersionStatus(versionId) {
    try {
      const response = await api.get(`/user-version-files/versions/${versionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // { versions: [{ id, version, is_latest, file|null }] } for one user+product
  async getUserProductStatus(userId, productId) {
    try {
      const response = await api.get(
        `/user-version-files/users/${userId}/products/${productId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // { users: [{ id, email }] } — license-server users of a product
  async getProductLicenseServerUsers(productId) {
    try {
      const response = await api.get(
        `/user-version-files/products/${productId}/users`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
